




























































import UserRequired from "../UserRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "@/components/start/Api";
import {
  datasourceSelectItems,
  NotificationConfig,
  NotificationSensor,
  WeekDays,
  WhenType,
  whenTypeToText
} from "@/modules/notificationmodels";
import {Company, EmailAddress} from "@/modules/models";
import rd from "../../modules/vRoutedefs";

interface SelectItem {
  text: string;
  value: any;
}

@Component
export default class NotificationConfigAddDialog extends UserRequired {
  @Inject()
  api!: Api;

  @Prop({default: false})
  value!: boolean;

  get opened() {
    return this.value;
  }
  set opened(v: boolean) {
    this.$emit("input", v);
  }

  readonly userprofileTo = {name: rd.start.me.name, query: {"trigger-email-add": true}};

  readonly whenTypeWeekly = WhenType.Weekly;

  step = 1;

  datasources = datasourceSelectItems;


  configStartTxt(config: NotificationConfig) {
    const interval1 = config.whenType == WhenType.Weekly ? config.whenWeekDayText : config.whenType == WhenType.Daily ? "dag" : "???";
    return `Hver ${interval1} klokken ${this.hourFormatted(config.whenHour || 0)}:00 sendes det varsel til ${config.toEmail.address} hvis noen av sensorene har varslingsinformasjon.`;
  }

  addDatasource: SelectItem | null = null;

  @Watch("addDatasource")
  onAddDatasource() {
    if(this.addDatasource != null) {
      if(this.addCompany == null) {
        this.step = 2;
      } else {
        this.step = 3;
      }
    }
  }

  get step1Caption() {
    if(this.step > 1 && this.addDatasource?.text) {
      const dsName = this.addDatasource?.text || "";
      return `Rapporter: ${dsName}`;
    } else {
      return `Rapporter`
    }
  }

  step1Valid(): boolean {
    return this.step <= 1 || this.addDatasource != null ;
  }

  get companyListing() {
    return this.user.usersCompanies();
  }

  addCompany: Company | null = null

  @Watch("addCompany")
  onAddCompany() {
    if(this.addCompany != null) {
      this.step = 3;
    }
  }

  get step2Caption() {
    if(this.addCompany) {
      return `Parametre: ${this.addCompany.name}`;
    } else {
      return "Parametre";
    }
  }

  // return true if
  step2Valid(): boolean {
    return this.step <= 2 || this.addCompany != null;
  }

  get whenTypeListing() {
    return [
      {text: whenTypeToText(WhenType.Weekly), value: WhenType.Weekly},
      {text: whenTypeToText(WhenType.Daily), value: WhenType.Daily},
    ]
  }

  get whenWeekdayListing() {
    return [
      {text: "Mandag", value: WeekDays.Mon},
      {text: "Tirsdag", value: WeekDays.Tue},
      {text: "Onsdag", value: WeekDays.Wed},
      {text: "Torsdag", value: WeekDays.Thu},
      {text: "Fredag", value: WeekDays.Fri},
      {text: "Lørdag", value: WeekDays.Sat},
      {text: "Søndag", value: WeekDays.Sun},
    ];
  }

  hourFormatted(h: number) {
    return String(h).padStart(2, "0");
  }

  get whenHourListing() {
    const ret: SelectItem[] = [];
    for(let h = 0; h < 24; h++) {
      const hStr = this.hourFormatted(h);
      ret.push({text: `Kl ${hStr}:00`, value: h});
    }
    return ret;
  }

  addWhenType: WhenType | null = null;
  addWhenWeekday: WeekDays = this.whenWeekdayListing[2].value;
  addWhenHour: number = 10;

  get step3Caption() {
    if(this.addWhenType) {
      const typTxt = this.whenTypeListing.find(r => r.value === this.addWhenType)?.text || "";
      const dayTxt = this.whenWeekdayListing.find(r => r.value === this.addWhenWeekday)?.text || "";
      return `Varslingstid: ${typTxt}, ${dayTxt} kl ${this.hourFormatted(this.addWhenHour)}:00`;
    } else {
      return `Varslingstid`;
    }
  }

  step3Valid(): boolean {
    return this.step <= 3 || (this.addWhenType != null && (this.addWhenWeekday != null || this.addWhenType == WhenType.Daily) && this.addWhenHour != null);
  }

  get recipientListing() {
    return this.user.emailAddresses;
  }

  addRecipient: EmailAddress | null = null;

  @Watch("addRecipient")
  onAddRecipient() {
    if(this.addRecipient) {
      this.step = 5;
    }
  }

  get step4Caption() {
    if(this.addRecipient) {
      return `Varslingsmottaker: ${this.addRecipient.address}`;
    } else {
      return `Varslingsmottaker`;
    }
  }

  step4Valid() {
    return this.step <= 4 || this.addRecipient != null;
  }

  get addConfigOk() {
    return this.addDatasource != null && this.addCompany != null && this.addWhenType != null && this.addWhenHour != null &&
        (this.addWhenWeekday != null || this.addWhenType == WhenType.Daily) && this.addRecipient != null;
  }

  working = false;
  async addConfig() {
    this.working = true;
    try {
      if (this.addRecipient != null && this.addWhenType != null && this.addDatasource != null && this.addCompany != null) {
        const sensor = new NotificationSensor(0, this.addDatasource.value, this.addCompany);
        const config = new NotificationConfig(0, this.user.person.guid, this.addRecipient, this.addWhenType, this.addWhenWeekday, this.addWhenHour, [sensor], null);
        await this.api.addNotificationConfig(config);
        //Load and show new sensor config
        this.$emit("at-notif-config-added");
        this.opened = false;
      }
    } finally {
      this.working = false;
    }
  }

  created() {
    // If user only has access to one company, we choose it for him
    if(this.user.usersCompanies().length == 1) {
      this.addCompany = this.user.usersCompanies()[0];
    }
  }

}
